// extracted by mini-css-extract-plugin
module.exports = {"errorText":"InputError_errorText__MLYfX","popup":"InputError_popup__9829i","menu":"InputError_menu__Ie_LW","fadeIn":"InputError_fadeIn__H4J5Q","spin":"InputError_spin__2Ldvc"};